import { render, staticRenderFns } from "./CampContacts.vue?vue&type=template&id=ade2fc60&lang=pug&"
import script from "./CampContacts.vue?vue&type=script&lang=js&"
export * from "./CampContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports